import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface wordAnimationObjI {
  show_brush: boolean
  fade: boolean
  cur_idx: number
}
interface wordAnimationI {
  wordAnimation: wordAnimationObjI
}
const initialState: wordAnimationI = {
  wordAnimation: { show_brush: false, fade: false, cur_idx: -1 }
}

export const setWordAnimationObjSlice = createSlice({
  name: 'setWordAnimation',
  initialState,
  reducers: {
    setWordAnimationObj: (state, action: PayloadAction<wordAnimationObjI>) => {
      state.wordAnimation = action.payload
    }
  }
})
export const { setWordAnimationObj } = setWordAnimationObjSlice.actions
export default setWordAnimationObjSlice.reducer
